import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import { push } from "react-router-redux";
import Helper from "../../helpers/helpers";

export function* loadUserList() {
  
  yield takeEvery(actionTypes.LOAD_USER_LIST, function*(action) {

    if(!action.data) action.data = {}
    let search = (action.data.search) ? action.data.search : ""
    let status = (action.data.status) ? action.data.status : ""
    let organization_user = (action.data.organization_user) ? "org" : ""

    let track_no = Helper.generateTrackNo(`USERLIST${search}${status}${organization_user}`);
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadUserList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadUserListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserListFail());
    }
  });
}
  
export function* loadUserFilter() {
  
  yield takeEvery(actionTypes.LOAD_USER_FILTER, function*(action) {

    if(!action.data) action.data = {}
    
    let offset = (action.data.offset) ? action.data.offset : ""
    let limit = (action.data.limit) ? action.data.limit : ""
    let search = (action.data.search) ? action.data.search : ""

    let track_no = Helper.generateTrackNo(`USERFILTER${offset}${limit}${search}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadUserList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadUserFilterSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserFilterFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserFilterFail());
    }
  });
}

export function* userCount() {
  
  yield takeEvery(actionTypes.USER_COUNT, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("USERCOUNT");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.userCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.userCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.userCountFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.userCountFail());
    }
  });
}

export function* switchUserToOrganizationType() {
  yield takeEvery(actionTypes.SWITCH_USER_TO_ORGANIZATION_TYPE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SWITCHUSERTYPE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.switchUserToOrganizationType(action.id, action.data);
      if (response.data.success) {
        yield put(actions.switchUserToOrganizationTypeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.switchUserToOrganizationTypeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.switchUserToOrganizationTypeFail());
    }
  });
}


export function* editUserDetail() {
  yield takeEvery(actionTypes.EDIT_USER_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSERDETAIL");

    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserDetail(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserDetailSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editUserDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserDetailFail());
    }
  });
}

export function* removeUser() {
  yield takeEvery(actionTypes.REMOVE_USER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("DELUSER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeUser(action.id, action.data);
      if (response.data.success) {
        yield put(actions.removeUserSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(push("/organization/user"));
      } else {
        alert(response.data.message);
        yield put(actions.removeUserFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeUserFail());
    }
  });
}

export function* recoveryUser() {
  yield takeEvery(actionTypes.RECOVERY_USER, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("RECOVERYUSER");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.recoveryUser(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.recoveryUserSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.recoveryUserFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.recoveryUserFail());
    }
  });
}

export function* editUserStatus() {
  yield takeEvery(actionTypes.EDIT_USER_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSERSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

        // if(action.listParams)
        //   yield put(actions.loadUserList(action.listParams));
        // else
        //   yield put(actions.loadUserDetail(action.id));

      } else {
        alert(response.data.message);
        yield put(actions.editUserStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserStatusFail());
    }
  });
}

export function* editUserLoginShowVeriCodeStatus() {
  yield takeEvery(actionTypes.EDIT_USER_SHOW_VERI_CODE_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSERSHOWVERICODESTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserLoginShowVeriCodeStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserLoginShowVeriCodeStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

        // if(action.listParams)
        //   yield put(actions.loadDriverList(action.listParams));
        // else
        //   yield put(actions.loadDriverDetail(action.id));
      } else {
        alert(response.data.message);
        yield put(actions.editUserLoginShowVeriCodeStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserLoginShowVeriCodeStatusFail());
    }
  });
}

export function* editUserGroupBonusStatus() {
  yield takeEvery(actionTypes.EDIT_USER_GROUP_BONUS_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSERGROUPBONUSSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserGroupBonusStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserGroupBonusStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editUserGroupBonusStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserGroupBonusStatusFail());
    }
  });
}

export function* editUserVerifyStatus() {
  yield takeEvery(actionTypes.EDIT_USER_VERIFY_STATUS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSERVERIFYSTATUS");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserVerifyStatus(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserVerifyStatusSuccess());
        yield put(actions.toastSuccess(response.data.message));

        // if(action.listParams)
        //   yield put(actions.loadUserList(action.listParams));
        // else
        //   yield put(actions.loadUserDetail(action.id));
      } else {
        alert(response.data.message);
        yield put(actions.editUserVerifyStatusFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserVerifyStatusFail());
    }
  });
}


export function* loadUserDetail() {
  
  yield takeEvery(actionTypes.LOAD_USER_DETAIL, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("USERDETAIL");
    action.data.track_no = track_no


    yield put(actions.enableLoading());
    try {
      const response = yield API.loadUserDetail(action.id, action.data);
      
      if (response.data.success && response.data.data) {
        
        yield put(actions.loadUserDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserDetailFail());
    }
  });
}



export function* loadUserSummary() {
  
  yield takeEvery(actionTypes.LOAD_USER_SUMMARY, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("USERSUMMARY");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadUserSummary(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadUserSummarySuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserSummaryFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserSummaryFail());
    }
  });
}

export function* setUserBillingAddress() {
  yield takeEvery(actionTypes.SET_USER_BILLING_ADDRESS, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETUSERBILLINGADDR");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setUserBillingAddress(action.id, action.data);
      if (response.data.success) {
        yield put(actions.setUserBillingAddressSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.setUserBillingAddressFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setUserBillingAddressFail());
    }
  });
}

export function* loadUserDeviceList() {
  
  yield takeEvery(actionTypes.LOAD_USER_DEVICE_LIST, function*(action) {

    if(!action.data) action.data = {}
    
    let search = (action.data.search) ? action.data.search : ""
    let dev_mode = (action.data.dev_mode) ? action.data.dev_mode : ""
    let user_id = (action.data.user_id) ? action.data.user_id : ""
    
    let track_no = Helper.generateTrackNo(`USERDEVICELIST${search}${dev_mode}${user_id}`);

    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadUserDeviceList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadUserDeviceListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserDeviceListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserDeviceListFail());
    }
  });
}
export function* logoutUserDevice() {
  yield takeEvery(actionTypes.LOGOUT_USER_DEVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("LOGOUTUSERDEVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.logoutUserDevice(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.logoutUserDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.logoutUserDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.logoutUserDeviceFail());
    }
  });
}

export function* removeUserDevice() {
  yield takeEvery(actionTypes.REMOVE_USER_DEVICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REMOVEUSERDEVICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.removeUserDevice(action.id, action.data);
      if (response.data.success) {
        
        yield put(actions.removeUserDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.removeUserDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeUserDeviceFail());
    }
  });
}

export function* devModeUserDevice() {
  yield takeEvery(actionTypes.SET_USER_DEVICE_DEV_MODE, function*(action) {

    let track_no = Helper.generateTrackNo("USERDEVICEDEV");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.devModeUserDevice(action.id, action.data);
      if (response.data.success) {

        yield put(actions.devModeUserDeviceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.devModeUserDeviceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.devModeUserDeviceFail());
    }
  });
}

export function* loadUserCreditTermRequestList() {
  
  yield takeEvery(actionTypes.LOAD_USER_CREDIT_TERM_REQEUST_LIST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("USERCREDITTERMREQUESTLIST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.loadUserCreditTermRequestList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadUserCreditTermRequestListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadUserCreditTermRequestListFail());
      }

      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadUserCreditTermRequestListFail());
    }
  });
}

export function* approveUserCreditTerm() {
  yield takeEvery(actionTypes.APPROVE_USER_CREDIT_TERM_REQEUST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("APPRUSERCREDITTERMREQUEST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.approveUserCreditTerm(action.id, action.data);
      if (response.data.success) {
        yield put(actions.approveUserCreditTermSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.approveUserCreditTermFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.approveUserCreditTermFail());
    }
  });
}

export function* rejectUserCreditTerm() {
  yield takeEvery(actionTypes.REJECT_USER_CREDIT_TERM_REQEUST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("REJECTUSERCREDITTERMREQUEST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.rejectUserCreditTerm(action.id, action.data);
      if (response.data.success) {
        yield put(actions.rejectUserCreditTermSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.rejectUserCreditTermFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.rejectUserCreditTermFail());
    }
  });
}

export function* cancelUserCreditTerm() {
  yield takeEvery(actionTypes.CANCEL_USER_CREDIT_TERM_REQEUST, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("CANCELUSERCREDITTERMREQUEST");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.cancelUserCreditTerm(action.id, action.data);
      if (response.data.success) {
        yield put(actions.cancelUserCreditTermSuccess());
        yield put(actions.toastSuccess(response.data.message));

      } else {
        alert(response.data.message);
        yield put(actions.cancelUserCreditTermFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.cancelUserCreditTermFail());
    }
  });
}

export function* setUserNegoPrice() {
  yield takeEvery(actionTypes.SET_USER_NEGO_PRICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETUSERNEGOPRICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setUserNegoPrice(action.id, action.data);
      if (response.data.success) {
        yield put(actions.setUserNegoPriceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.setUserNegoPriceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setUserNegoPriceFail());
    }
  });
}

export function* setQuotationState() {
  yield takeEvery(actionTypes.SET_QUOTATION_STATE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("SETQUOTATIONSTATE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.setQuotationState(action.id, action.data);
      if (response.data.success) {
        yield put(actions.setQuotationStateSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.setQuotationStateFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.setQuotationStateFail());
    }
  });
}

export function* countPendingEInvoiceWalletVerifed() {
  yield takeEvery(actionTypes.COUNT_PENDING_EINVOICE_WALLET_VERIFIED, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("COUNTPENDINGEINVOICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.countPendingEInvoiceWalletVerifed(action.data);
      
      if (response.data.success && response.data.data !== undefined) {
        
        yield put(actions.countPendingEInvoiceWalletVerifedSuccess(response.data.data));
        
      } else {
        alert(response.data.message);
        yield put(actions.countPendingEInvoiceWalletVerifedFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.countPendingEInvoiceWalletVerifedFail());
    }
  });
}

export function* processPendingEInvoiceWalletVerifed() {
  yield takeEvery(actionTypes.PROCESS_PENDING_EINVOICE_WALLET_VERIFIED, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("PROCESSPENDINGEINVOICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.processPendingEInvoiceWalletVerifed(action.data);
      if (response.data.success) {
        yield put(actions.processPendingEInvoiceWalletVerifedSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.processPendingEInvoiceWalletVerifedFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.processPendingEInvoiceWalletVerifedFail());
    }
  });
}

export function* updateWalletEInvoice() {
  yield takeEvery(actionTypes.UPDATE_WALLET_EINVOICE, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("UPDATEWALLETEINVOICE");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.updateWalletEInvoice(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateWalletEInvoiceSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.updateWalletEInvoiceFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateWalletEInvoiceFail());
    }
  });
}

export function* excelUpdateUserEInvoiceTIN() {
  yield takeEvery(actionTypes.EXCEL_UPDATE_USER_TIN, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EXCELUPDATEUSERTIN");
    
    if(action.data instanceof FormData)
      action.data.append("track_no", track_no);
      
    else
      action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.excelUpdateUserEInvoiceTIN(action.data);
      if (response.data.success) {
        
        if(response.data.data)
        {
          Helper.loadSecureFile(response.data.data.file_path, file => {
            
            var downloadLink = document.createElement("a");
            downloadLink.href = file;
            downloadLink.download = response.data.data.file_name;
  
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          });
        }
        yield put(actions.excelUpdateUserEInvoiceTINSuccess());
        yield put(actions.toastSuccess(response.data.message));
        
      } else {
        alert(response.data.message);
        yield put(actions.excelUpdateUserEInvoiceTINFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.excelUpdateUserEInvoiceTINFail());
    }
  });
}

export function* editUserEduRanking() {
  yield takeEvery(actionTypes.EDIT_USER_EDU_RANKING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSEREDURANKING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserEduRanking(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserEduRankingSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editUserEduRankingFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserEduRankingFail());
    }
  });
}

export function* editUserExcludeRanking() {
  yield takeEvery(actionTypes.EDIT_USER_EXCLUDE_RANKING, function*(action) {

    if(!action.data) action.data = {}

    let track_no = Helper.generateTrackNo("EDITUSEREXCLUDERANKING");
    action.data.track_no = track_no

    yield put(actions.enableLoading());

    try {
      const response = yield API.editUserExcludeRanking(action.id, action.data);
      if (response.data.success) {
        yield put(actions.editUserExcludeRankingSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.editUserExcludeRankingFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.editUserExcludeRankingFail());
    }
  });
}

export default function* UserSaga() {
  yield all([fork(loadUserList)]);
  yield all([fork(loadUserFilter)]);
  yield all([fork(userCount)]);
  yield all([fork(switchUserToOrganizationType)]);  
  yield all([fork(editUserDetail)]);
  yield all([fork(removeUser)]);  
  yield all([fork(recoveryUser)]);  
  yield all([fork(editUserStatus)]);
  yield all([fork(editUserLoginShowVeriCodeStatus)]);
  yield all([fork(editUserGroupBonusStatus)]);
  yield all([fork(editUserVerifyStatus)]);
  yield all([fork(loadUserDetail)]);
  yield all([fork(loadUserSummary)]);
  yield all([fork(setUserBillingAddress)]);
  yield all([fork(loadUserDeviceList)]);
  yield all([fork(logoutUserDevice)]);
  yield all([fork(removeUserDevice)]);
  yield all([fork(devModeUserDevice)]);
  yield all([fork(loadUserCreditTermRequestList)]);
  yield all([fork(approveUserCreditTerm)]);
  yield all([fork(rejectUserCreditTerm)]);
  yield all([fork(cancelUserCreditTerm)]);
  yield all([fork(setUserNegoPrice)]);
  yield all([fork(setQuotationState)]);
  yield all([fork(countPendingEInvoiceWalletVerifed)]);
  yield all([fork(processPendingEInvoiceWalletVerifed)]);
  yield all([fork(updateWalletEInvoice)]);
  yield all([fork(excelUpdateUserEInvoiceTIN)]);
  yield all([fork(editUserEduRanking)]);
  yield all([fork(editUserExcludeRanking)]);
}
